'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bestSupportUrlFor = exports.bestWixUrlFor = exports.bestWixLocaleFor = exports.bestLocaleFor = undefined;

var _Wix = require('./Wix');

var Wix = _interopRequireWildcard(_Wix);

var _Countries = require('./Countries');

var Countries = _interopRequireWildcard(_Countries);

var _Locales = require('./Locales');

var Locales = _interopRequireWildcard(_Locales);

var _Languages = require('./Languages');

var Languages = _interopRequireWildcard(_Languages);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _localeHelpers = require('locale-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// If the country's language is not supported by Wix, we ignore the user's Wix language
// because she never really had a choice
var bestLanguageFor = function bestLanguageFor(_ref) {
	var userLanguage = _ref.userLanguage,
	    countryLanguage = _ref.countryLanguage;

	if (countryLanguage && !_lodash2.default.includes(Wix.supportedLanguages, countryLanguage)) {
		return countryLanguage;
	} else {
		return userLanguage;
	}
};

var bestLocaleFor = exports.bestLocaleFor = function bestLocaleFor(_ref2) {
	var wixUserLanguage = _ref2.wixUserLanguage,
	    countryCode = _ref2.countryCode;

	// Infer the most suitable language
	return _localeHelpers.LocaleHelpers.bestLocaleFor({
		language: bestLanguageFor({
			userLanguage: Wix.nonStandardLanguages[wixUserLanguage] || wixUserLanguage,
			countryLanguage: Countries.languages[countryCode]
		}),
		country: countryCode
	});
};

var bestWixLocaleFor = exports.bestWixLocaleFor = function bestWixLocaleFor(_ref3) {
	var wixUserLanguage = _ref3.wixUserLanguage,
	    countryCode = _ref3.countryCode;

	// Keep Wix language
	return _localeHelpers.LocaleHelpers.bestLocaleFor({
		language: Wix.nonStandardLanguages[wixUserLanguage] || wixUserLanguage,
		country: countryCode
	});
};

var subdomainFor = function subdomainFor(_ref4) {
	var locale = _ref4.locale;

	var language = locale.substr(0, 2);

	// Handle languages with non-standard domains
	var nonStandardDomain = Wix.nonStandardLanguageDomains[language];
	if (nonStandardDomain) {
		return nonStandardDomain;
	}

	// Handle languages with standard domains
	if (_lodash2.default.includes(Wix.supportedLanguages, language)) {
		return language;
	}

	// If all else fails, use the domain for English (United States)
	return subdomainFor({
		locale: 'en_US'
	});
};

var bestWixUrlFor = exports.bestWixUrlFor = function bestWixUrlFor(_ref5) {
	var locale = _ref5.locale,
	    path = _ref5.path;

	return 'https://' + subdomainFor({ locale: locale }) + '.wix.com/' + path;
};

var bestSupportUrlFor = exports.bestSupportUrlFor = function bestSupportUrlFor(_ref6) {
	var locale = _ref6.locale,
	    article = _ref6.article;

	var language = locale.substr(0, 2);

	// Map to supported Wix language (default: 'en')
	var wixLangauge = 'en';
	if (_lodash2.default.includes(Wix.supportedLanguages, language)) {
		wixLangauge = Wix.nonStandardWixLanguages[language] || language;
	}

	return 'https://support.wix.com/' + wixLangauge + '/article/' + article;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-locales/dist/WixLocales.js
// module id = 859
// module chunks = 0